import { Box, BoxProps, Typography, useTheme } from '@mui/material'
import { FlexCol, FlexGrowRow, FlexRow } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import React from 'react'

import ComponentSize from '../../ComponentSize'
import { AuctionCard } from '../Auction'

interface Props extends BoxProps {
  hideQuadkey?: boolean
  hideTitle?: boolean
  hideValue?: boolean
  page?: string
  quadkey?: Quadkey
  size?: ComponentSize
  spacing?: number
}

const Parent: React.FC<Props> = ({ hideValue, hideTitle, hideQuadkey, quadkey, page = 'auction', size = 'medium', spacing = 1, ...props }) => {
  const parentQuadkey = quadkey?.parent() ?? Quadkey.root
  const theme = useTheme()
  return (
    <FlexCol alignItems="stretch" {...props}>
      {!hideTitle ? (
        <FlexRow borderBottom={`solid 1px ${theme.palette.divider}`}>
          <Typography variant="caption">Parent</Typography>
        </FlexRow>
      ) : null}
      <FlexGrowRow>
        <Box display={parentQuadkey ? 'flex' : 'none'} justifyContent="center">
          <AuctionCard hideQuadkey={hideQuadkey} hideValue={hideValue} page={page} quadkey={parentQuadkey} size={size} margin={spacing} />
        </Box>
      </FlexGrowRow>
    </FlexCol>
  )
}

export default Parent
